import { Icon } from 'components/Basic/Icon/Icon';
import { styled } from 'components/Theme/main';

export const HamburgerIconOpenStyled = styled(Icon)`
    width: 16px;
    height: 16px;
`;
